<template>
  <div>
    <b-row>
      <b-col cols="4">
        <b-card title="节能概览" class="card-tile">
          <b-row>
            <b-col cols="6">
              <div id="card2-gauge1" style="height: 12rem"></div>

              <div class="border rounded p-1 mt-2">
                <div>
                  <label>诊断结论</label>
                </div>
                <b-icon-star-fill variant="success"></b-icon-star-fill>
                <b-icon-star-fill variant="success"></b-icon-star-fill>
                <b-icon-star-half variant="success"></b-icon-star-half>
                <b-icon-star variant="success"></b-icon-star>
                <b-icon-star variant="success"></b-icon-star>
                <div>运行不佳，节能空间较大，建议尽快采取节能优化措施。</div>
              </div>
            </b-col>
            <b-col cols="6">
              <b-alert show variant="primary">
                <div class="alert-body d-flex align-items-center justify-content-between">
                  <div>
                    <div class="d-flex align-items-end">
                      <h1 style="font-size: 2.5rem" class="mb-0 font-digit">
                        123,456
                        <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                      </h1>
                      <label class="ml-25">kWh</label>
                    </div>
                    <p>节能潜力 <b-icon-graph-down /></p>
                  </div>
                  <b-avatar size="48" variant="light-primary">
                    <b-icon-lightning-fill scale="2"></b-icon-lightning-fill>
                  </b-avatar>
                </div>
              </b-alert>

              <b-alert show variant="primary">
                <div class="alert-body d-flex align-items-center justify-content-between">
                  <div>
                    <div class="d-flex align-items-end">
                      <h1 class="mb-0 font-digit">
                        <label class="ml-25">￥</label>123,456
                        <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                      </h1>
                      <label class="ml-25">元</label>
                    </div>
                    <p>节费潜力 <b-icon-graph-down /></p>
                  </div>
                  <b-avatar size="48" variant="light-primary">
                    <b-icon-currency-exchange scale="2"></b-icon-currency-exchange>
                  </b-avatar>
                </div>
              </b-alert>

              <div class="mt-3">
                <div class="d-flex align-items-center">
                  <b-avatar rounded size="28" variant="light-info">
                    <b-icon-lightning-fill scale="1.25"></b-icon-lightning-fill>
                  </b-avatar>
                  <span class="ml-50">基准能耗</span>
                </div>
                <div class="d-flex align-items-end">
                  <h2 class="mb-0 font-digit">
                    123,456,789
                    <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                  </h2>
                  <label class="ml-25">kWh</label>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card title="节能分析" class="card-tile">
          <b-row>
            <b-col cols="6">
              <div id="card3_pie" style="height: 15rem"></div>

              <div class="border rounded p-1 mt-50">
                <div class="d-flex align-items-center">
                  <b-avatar rounded size="28" variant="light-info">
                    <b-icon-lightning-fill scale="1.25"></b-icon-lightning-fill>
                  </b-avatar>
                  <span class="ml-50">Title</span>
                </div>
                <div class="d-flex align-items-end">
                  <h2 class="mb-0 font-digit">
                    123
                    <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                  </h2>
                  <label class="ml-25">kWh</label>
                </div>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="text-center"><label>节能潜力 TOP 10</label></div>
              <div id="card3_bar" style="height: 20rem"></div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card title="诊断数" class="card-tile">
          <b-row>
            <b-col cols="6">
              <h1 style="font-size: 2.5rem" class="mt-3 mb-0 font-digit">
                1,234.5k
                <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
              </h1>
              <p>{{ $t('诊断数据总量') }}</p>

              <h1 class="mt-2 mb-0 font-digit">
                12.3k
                <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
              </h1>
              <p>{{ $t('诊断总点位数') }}</p>
            </b-col>
            <b-col cols="6">
              <b-alert show variant="primary">
                <div class="alert-body">
                  <h1 style="font-size: 2.5rem" class="mb-0 mt-25 font-digit">
                    123
                    <span v-if="riskLoading"><img src="/images/loading.svg" alt="" /></span>
                  </h1>
                  <p>节能潜力点</p>
                </div>
              </b-alert>

              <b-alert show variant="primary">
                <div class="alert-body">
                  <h1 style="font-size: 2.5rem" class="mb-0 mt-25 font-digit">
                    12
                    <span v-if="riskLoading"><img src="/images/loading.svg" alt="" /></span>
                  </h1>
                  <p>节能潜力设备</p>
                </div>
              </b-alert>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="4">
              <div class="border rounded p-1">
                <span class="bullet bullet-danger bullet-sm mr-50"></span>
                {{ $t('重要') }}
                <h3 class="font-digit">
                  1
                  <span v-if="riskLoading"><img src="/images/loading.svg" alt="" /></span>
                </h3>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="border rounded p-1">
                <span class="bullet bullet-warning bullet-sm mr-50"></span>
                {{ $t('一般') }}
                <h3 class="font-digit">
                  12
                  <span v-if="riskLoading"><img src="/images/loading.svg" alt="" /></span>
                </h3>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="border rounded p-1">
                <span class="bullet bullet-info bullet-sm mr-50"></span>
                {{ $t('提醒') }}
                <h3 class="font-digit">
                  123
                  <span v-if="riskLoading"><img src="/images/loading.svg" alt="" /></span>
                </h3>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card title="能耗对比" class="card-tile">
          <div style="position: absolute; top: 1rem; right: 1rem; width: 10rem;">
            <b-select :options="systemOpt" required></b-select>
          </div>
          <div id="card4_column" style="height: 15rem"></div>

          <b-row class="mt-2">
            <b-col cols="12">
              <div class="border rounded p-1">
                <b-row>
                  <b-col cols="4">
                    <div class="d-flex align-items-center justify-content-between mb-25">
                      <div class="d-flex align-items-center">
                        <b-avatar rounded size="28" variant="light-primary">
                          <b-icon-lightning-fill scale="1.25"></b-icon-lightning-fill>
                        </b-avatar>
                        <span class="ml-50">Title</span>
                      </div>
                      <h4 class="mt-50 font-digit">
                        0%
                        <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                      </h4>
                    </div>
                    <b-progress :value="0" max="100" height=".5rem" variant="primary"></b-progress>
                  </b-col>

                  <b-col cols="4">
                    <div class="d-flex align-items-center justify-content-between mb-25">
                      <div class="d-flex align-items-center">
                        <b-avatar rounded size="28" variant="light-info">
                          <b-icon-lightning-fill scale="1.25"></b-icon-lightning-fill>
                        </b-avatar>
                        <span class="ml-50">Title</span>
                      </div>
                      <h4 class="mt-50 font-digit">
                        0%
                        <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                      </h4>
                    </div>
                    <b-progress :value="0" max="100" height=".5rem" variant="info"></b-progress>
                  </b-col>

                  <b-col cols="4">
                    <div class="d-flex align-items-center justify-content-between mb-25">
                      <div class="d-flex align-items-center">
                        <b-avatar rounded size="28" variant="light-success">
                          <b-icon-lightning-fill scale="1.25"></b-icon-lightning-fill>
                        </b-avatar>
                        <span class="ml-50">Title</span>
                      </div>
                      <h4 class="mt-50 font-digit">
                        0%
                        <span v-if="topLoading"><img src="/images/loading.svg" alt="" /></span>
                      </h4>
                    </div>
                    <b-progress :value="0" max="100" height=".5rem" variant="success"></b-progress>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card title="节能统计" class="card-tile">
          <b-row>
            <b-col cols="12">
              <b-tabs fill>
                <b-tab @click="handleChangeRiskStatics(riskStatics.year_data)" :title="$t('近12月')" active> </b-tab>
                <b-tab @click="handleChangeRiskStatics(riskStatics.day_14_data)" :title="$t('近14日')"></b-tab>
                <b-tab @click="handleChangeRiskStatics(riskStatics.hour_24_data)" :title="$t('近24时')"></b-tab>
                <div id="card1_column" style="height: 13rem"></div>
              </b-tabs>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-around">
                <div>
                  <h2 class="my-0 font-digit">
                    0
                  </h2>
                  <p>今日节能潜力</p>
                </div>
                <div class="ml-4">
                  <h2 class="my-0 font-digit">
                    0
                  </h2>
                  <p>本月节能潜力</p>
                </div>
                <div class="ml-4">
                  <h2 class="my-0 font-digit">
                    0
                  </h2>
                  <p>年度节能潜力</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card title="诊断报告" class="card-tile">
          <div class="d-flex align-items-center" style="gap: 0.5rem;">
            <b-button variant="primary" @click="$refs['paramsModal'].show()">基础参数</b-button>
            <b-button variant="primary">上传数据</b-button>
            
            <b-button variant="primary">生成报告</b-button>
          </div>
          <div class="mt-1">
            <!-- <vue-perfect-scrollbar style="height: 600px"> -->
            <b-table :fields="fields" :items="items" sticky-header small striped no-border-collapse>
              <template #cell(id)="data">
                {{ data.index + 1 }}
              </template>
              <!-- <template #cell(level)="data">
                <div :class="data.item.level == '重要' ? 'red' : 'yellow'">{{ data.value }}</div>
              </template>
              <template #cell(ratio)="data">
                <div :class="data.item.level == '重要' ? 'red' : 'yellow'">{{ data.value }}</div>
              </template> -->
            </b-table>
            <!-- </vue-perfect-scrollbar> -->
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="paramsModal" size="lg" no-close-on-backdrop no-close-on-esc title="输入参数">
      <div class="d-block">
        <p>工作时间：XXX</p>
        <p>设计冷冻水供回水温差:XX</p>
        <p>计冷却水供回水温差:XX</p>
        <p>设计冷却逼近度:XX</p>
        <p>...</p>
        <p>冷却泵1:额定功率:XX,额定频率:XX</p>
        <p>冷却泵2:额定功率:XX,额定频率:XX</p>
        <p>...</p>
        <p>冷却泵1:额定功率:XX,额定频率:XX</p>
        <p>冷却泵2:额定功率:XX,额定频率:XX</p>
        <p>...</p>
        <p>冷却泵1:额定功率:XX,额定频率:XX</p>
        <p>冷却泵2:额定功率:XX,额定频率:XX</p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="success" @click="confirm"> 确定 </b-button>
        <b-button size="sm" variant="danger" @click="$refs['paramsModal'].hide()"> 取消 </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { onMounted, ref, reactive, toRefs, computed } from '@vue/composition-api';
import { G2, Column, Pie, Gauge, RadialBar, Bar, Liquid } from '@antv/g2plot';
const { Util, registerShape } = G2;
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'ConservationDashboard',
  components: {
    VuePerfectScrollbar,
  },
  setup() {
		const event = reactive({
			topLoading: false,
			riskLoading: false,
		});
    const gauge = ref(null);
    const systemOpt = ref([
      { text: '制冷', value: 'cooling' },
      { text: '供暖', value: 'heating' },
      { text: '新风', value: 'fresh_air' },
      { text: '照明', value: 'lighting' },
      { text: '其他', value: 'other' },
    ]);
    const fields = [
      { key: 'id', label: '序号' },
      { key: 'equipment', label: '设备' },
      { key: 'level', label: '重要程度' },
      { key: 'ratio', label: '节能率' },
    ];
    const items = ref([
      { equipment: '#冷冻水泵节能预警', level: '重要', ratio: '20%' },
      { equipment: '#冷冻水泵节能预警', level: '一般', ratio: '10%' },
      { equipment: '#冷冻水泵节能预警', level: '一般', ratio: '10%' },
      { equipment: '#冷水机组', level: '重要', ratio: '30%' },
      { equipment: '#冷水机组', level: '重要', ratio: '32%' },
      { equipment: '#冷水机组', level: '重要', ratio: '34%' },
      { equipment: '#冷却泵', level: '提醒', ratio: '30%' },
    ]);
    const paramsModal = ref(null);
    /**
     * 绘制卡片1柱状图
     */
    const card1ColumnInit = () => {
      const card1ColumnInit = new Column('card1_column', {
        data: [
          {
            月份: '一月',
            能耗: 600,
          },
          {
            月份: '二月',
            能耗: 700,
          },
          {
            月份: '三月',
            能耗: 750,
          },
          {
            月份: '四月',
            能耗: 400,
          },
          {
            月份: '五月',
            能耗: 300,
          },
          {
            月份: '六月',
            能耗: 350,
          },
          {
            月份: '七月',
            能耗: 450,
          },
          {
            月份: '八月',
            能耗: 500,
          },
          {
            月份: '九月',
            能耗: 410,
          },
          {
            月份: '十月',
            能耗: 580,
          },
          {
            月份: '十一月',
            能耗: 370,
          },
          {
            月份: '十二月',
            能耗: 480,
          },
        ],
        xField: '月份',
        yField: '能耗',
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          title: {
            text: '节能量 (kWh)',
            // fontSize: '16px',
            style: {
              // fill: '#828385', // Y轴标题颜色
              // fontSize: 16,
            },
          },
          line: null,
          grid: null,
          label: null,
        },
        columnStyle: {
          radius: [5, 5, 5, 5],
        },
        slider: {
          start: 0,
          end: 1,
        },
      });
      card1ColumnInit.render();
    };
    /**
     * 自定义 Shape 部分
     */
    registerShape('point', 'custom-gauge-indicator', {
      draw(cfg, container) {
        // 使用 customInfo 传递参数
        const { indicator, defaultColor } = cfg.customInfo;
        const { pointer, pin } = indicator;

        const group = container.addGroup();
        // 获取极坐标系下画布中心点
        const center = this.parsePoint({ x: 0, y: 0 });

        if (pin) {
          const pinStyle = pin.style || {};
          const { lineWidth = 2, fill = defaultColor } = pinStyle;
          const r = 6;
          group.addShape('circle', {
            name: 'pin-outer',
            attrs: {
              x: center.x,
              y: center.y,
              ...pin.style,
              fill,
              r: r * 1.5,
              lineWidth,
            },
          });
        }
        // 绘制指针
        if (pointer) {
          const { startAngle, endAngle } = Util.getAngle(cfg, this.coordinate);
          const radius = this.coordinate.getRadius();
          const midAngle = (startAngle + endAngle) / 2;
          const { x: x1, y: y1 } = Util.polarToCartesian(center.x, center.y, radius / 15, midAngle + 1 / Math.PI);
          const { x: x2, y: y2 } = Util.polarToCartesian(center.x, center.y, radius / 15, midAngle - 1 / Math.PI);
          const { x, y } = Util.polarToCartesian(center.x, center.y, radius * 0.65, midAngle);
          const { x: x0, y: y0 } = Util.polarToCartesian(center.x, center.y, radius * 0.1, midAngle + Math.PI);
          const sa = Math.PI / 2 + midAngle;
          const r1 = 3.5;
          const p1 = {
            x: center.x + Math.cos(sa) * r1,
            y: center.y + Math.sin(sa) * r1,
          };
          const p2 = {
            x: center.x - Math.cos(sa) * r1,
            y: center.y - Math.sin(sa) * r1,
          };
          const r2 = r1 / 4;
          const p11 = {
            x: x + Math.cos(sa) * r2,
            y: y + Math.sin(sa) * r2,
          };
          const p21 = {
            x: x - Math.cos(sa) * r2,
            y: y - Math.sin(sa) * r2,
          };

          const path = [
            ['M', p21.x, p21.y],
            // 参数信息: cx, cy, .., .., .., endPointX, endPointY
            ['A', r2, r2, 0, 0, 1, p11.x, p11.y],
            ['L', p1.x, p1.y],
            ['A', r1, r1, 0, 0, 1, p2.x, p2.y],
            ['Z'],
          ];
          // pointer
          group.addShape('path', {
            name: 'pointer',
            attrs: {
              path,
              fill: defaultColor,
              lineCap: 'round',
              ...pointer.style,
            },
          });
          // pointer
          group.addShape('circle', {
            name: 'pointer-center',
            attrs: {
              x: center.x,
              y: center.y,
              r: 2,
              fill: '#fff',
            },
          });
        }
        return group;
      },
    });
    /**
     * 绘制仪表盘1
     */
    const card2Gauge1Init = () => {
      gauge.value = new Gauge('card2-gauge1', {
        percent: 0.12,
        type: 'meter',
        range: {
          ticks: [0, 1 / 4, 1 / 2, 3 / 4, 1],
          // color: ['#39B8FF', '#52619B', '#43E089', '#C0EDF3'],
        },
        axis: {
          tickInterval: 0.25, // 刻度线间隔
          label: {
            formatter(v) {
              return Number(v) * 100;
            },
          },
        },
        indicator: {
          shape: 'custom-gauge-indicator',
          pointer: {
            style: {
              stroke: '#CFCFCF',
              lineWidth: 1,
              fill: '#CFCFCF',
            },
          },
          pin: {
            style: {
              lineWidth: 2,
              stroke: '#D0D0D0',
              fill: '#D0D0D0',
            },
          },
        },
        statistic: {
          title: {
            content: "节能率",
            // color: '#4b535e',
          },
          content: {
            offsetY: 0,
            formatter: ({ percent }) => (percent * 100).toFixed(0) + '%',
            style: {
              fontSize: 28,
              // color: '#828385',
            },
          },
        },
      });
      gauge.value.render();
    };
    /**
     * 绘制仪表盘2
     */
    const card2Gauge2Init = () => {
      gauge.value = new Gauge('card2-gauge2', {
        percent: 0.5,
        type: 'meter',
        range: {
          ticks: [0, 1 / 4, 1 / 2, 3 / 4, 1],
          color: ['#39B8FF', '#52619B', '#43E089', '#C0EDF3'],
        },
        axis: {
          tickInterval: 0.25, // 刻度线间隔
          label: {
            formatter(v) {
              return Number(v) * 100;
            },
          },
        },
        indicator: {
          shape: 'custom-gauge-indicator',
          pointer: {
            style: {
              stroke: '#CFCFCF',
              lineWidth: 1,
              fill: '#CFCFCF',
            },
          },
          pin: {
            style: {
              lineWidth: 2,
              stroke: '#D0D0D0',
              fill: '#D0D0D0',
            },
          },
        },
        statistic: {
          content: {
            offsetY: 20,
            formatter: ({ percent }) => (percent * 100).toFixed(0),
            style: {
              fontSize: 40,
              color: '#828385',
            },
          },
        },
      });
      gauge.value.render();
    };
    /**
     * 绘制卡片3饼图
     */
    const card3PieInit = () => {
      const card3Pie = new Pie('card3_pie', {
        data: [
          { type: '制冷', value: 40 },
          { type: '供暖', value: 25 },
          { type: '新风', value: 20 },
          { type: '照明', value: 10 },
          { type: '其他', value: 5 },
        ],
        padding: [0, 0, 0, 0],
        angleField: 'value',
        colorField: 'type',
        color: ['#618BF4', '#6ACFA1', '#5D6C90', '#E7B504', '#6D5CF5'],
        radius: 0.8,
        label: {
          // type: 'inner',
          // offset: '-40%',
          content: (item) => {
            const percent = item.value / 100; // 手动计算百分比（总和为 100）
            return `${item.type}\n${(percent * 100).toFixed(0)}%`;
          },
          style: {
            // fontSize: 14,
            // textAlign: 'center',
            // fill: '#fff',
          },
        },
        legend: false, // 🚫 彻底禁用图例
      });
      card3Pie.render();
    };
    /**
     * 绘制卡片3条形图
     */
    const card3BarInit = () => {
      const card3Bar = new Bar('card3_bar', {
        data: [
          { type: '制冷机#1', value: 750 },
          { type: '冷却泵#2', value: 700 },
          { type: '制冷机#2', value: 600 },
          { type: '制冷机#3', value: 400 },
          { type: '冷冻泵#5', value: 300 },
          { type: '冷冻泵#1', value: 250 },
          { type: '制冷机#5', value: 200 },
          { type: '冷冻泵#2', value: 180 },
          { type: '新风机#1', value: 150 },
          { type: '冷却塔#5', value: 100 },
        ],
        xField: 'value',
        yField: 'type',
        seriesField: 'type',
        // color: ['#618BF4', '#6ACFA1', '#5D6C90', '#E7B504', '#6D5CF5'],

        xAxis: {
          title: {
            text: '节能潜力 (kWh)',
            style: {
              // fill: '#828385', // Y轴标题颜色
              // fontSize: 16,
            },
          },
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          line: null,
          grid: null,
          // label: null,
        },
        barStyle: {
          radius: [5, 5, 5, 5],
        },
        meta: {
          type: {
            alias: '类别',
          },
          value: {
            alias: '节能潜力',
          },
        },
        legend: false,
      });
      card3Bar.render();
    };
    /**
     * 绘制卡片4柱状图
     */
    const card4ColumnInit = () => {
      const card1ColumnInit = new Column('card4_column', {
        data: [
          {
            group: '当前能耗',
            设备: '冷水机组',
            能耗: 600,
          },
          {
            group: '当前能耗',
            设备: '冷却泵',
            能耗: 200,
          },
          {
            group: '当前能耗',
            设备: '冷冻泵',
            能耗: 200,
          },
          {
            group: '当前能耗',
            设备: '冷却塔',
            能耗: 600,
          },
          {
            group: '优化能耗',
            设备: '冷水机组',
            能耗: 350,
          },
          {
            group: '优化能耗',
            设备: '冷却泵',
            能耗: 120,
          },
          {
            group: '优化能耗',
            设备: '冷冻泵',
            能耗: 130,
          },
          {
            group: '优化能耗',
            设备: '冷却塔',
            能耗: 100,
          },
        ],
        isGroup: true,
        xField: '设备',
        yField: '能耗',
        seriesField: 'group',

        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          line: null,
          grid: null,
          label: null,
          title: {
            text: '节能量 (kWh)',
            // fontSize: '16px',
            style: {
              // fill: '#828385', // Y轴标题颜色
              // fontSize: 16,
            },
          },
        },
        columnStyle: {
          radius: [5, 5, 5, 5],
        },
        legend: {
          position: 'top',
          itemName: {
            style: {
              fill: '#828385', // 图例文字颜色
            },
          },
        },
      });
      card1ColumnInit.render();
    };
    const confirm = () => {
      console.log('?????????????????');
    };
    onMounted(() => {
      card1ColumnInit();
      card2Gauge1Init();
      // card2Gauge2Init();
      card3PieInit();
      card3BarInit();
      card4ColumnInit();
    });

    return {
      ...toRefs(event),
      systemOpt,
      fields,
      items,
      paramsModal,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 8px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent;
  /* 轨道背景色 */
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: rgba(126, 133, 148, 0.6);
  /* 滑块颜色 */
  // opacity: 0.1;
  border-radius: 8px;
}

/* 滚动条滑块悬停效果 */
::-webkit-scrollbar-thumb:hover {
  background: #727981;
  /* 悬停颜色 */
}

.red {
  color: #ff3e3e;
}

.yellow {
  color: #c5c500;
}

.card1 {
  height: 30.9rem;
  position: relative;

  .card-title {
    margin-bottom: 2.5rem;
  }

  .btn {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
}

.card2 {
  // height: 20rem;

  .tabs_conttent {
    ::v-deep .tab-content {
      margin-top: 2rem;

      h4 {
        margin-top: 2rem;
        text-align: center;
      }
    }
  }

  .data_conttent {
    .btn {
      margin-bottom: 1rem;
    }

    .mb_1 {
      margin-top: 1rem;

      .data_title {
        padding: 2rem 0;

        h2,
        h4 {
          text-align: center;
        }
      }
    }
  }
}

.card3 {
  height: 30.9rem;
}

.card4 {
  height: 30.9rem;
}

.card5 {
  position: relative;
  height: 63.8rem;

  .button_box {
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
}

.card-tile {
  height: 390px;
}
</style>
